import { Handle, Position } from '@xyflow/react'

interface Data {
  index: number // 1-based, mirrors the numbering in mlmodels.md
  emoji: string
  title: string // the real problem name ("Fraud Detection")
  question: string // the plain-English hook ("Which payment is a thief?")
  solved: boolean
  solvedMetric: string | null
  hot: boolean // auto-demo / expanded glow
}

export default function QuestionNode({ data }: { data: Data }) {
  return (
    <div
      className={
        'relative w-[240px] cursor-pointer rounded-2xl border px-4 py-3 transition-all hover:-translate-y-0.5 ' +
        (data.hot || data.solved
          ? 'border-brand-500/70 bg-ink-800 shadow-glow'
          : 'border-ink-600 bg-ink-850 hover:border-brand-500/60 hover:bg-ink-800')
      }
    >
      <Handle type="target" position={Position.Left} className="!h-2 !w-2 !border-0 !bg-ink-600" />
      {data.solved && (
        <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-brand-500 text-[12px] font-extrabold text-ink-950">
          ✓
        </span>
      )}
      <div className="flex items-center gap-2">
        <span className="text-[19px] leading-none">{data.emoji}</span>
        <span className="text-[10px] font-bold text-mut/70">{data.index}</span>
      </div>
      <div className="mt-1.5 text-[14.5px] font-bold leading-tight text-white">{data.title}</div>
      <div className="mt-1 text-[12px] leading-snug text-mut">{data.question}</div>
      {data.solved && data.solvedMetric && (
        <div className="mt-1 text-[11px] font-medium text-brand-300">solved · {data.solvedMetric}</div>
      )}
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-0 !bg-ink-600" />
    </div>
  )
}
